import moment from "moment";

export const isBrand = false;

export const getValidData = (data) => {
  return data === "-" || data == null ? "" : data;
};

export const checkInternalEmail = (email) => {
  return email.includes("esger") || email.includes("elm");
};

export const calculateAuditDueDataData = (timestamp) => {
  const currentDate = moment();
  const inputDate = moment(timestamp);
  const nextAuditDueDate = inputDate.clone().add(2, "years");
  const isPastDue = nextAuditDueDate.isBefore(currentDate);
  const daysUntilNextAudit = nextAuditDueDate.diff(currentDate, "days");
  return {
    lastAuditDate: inputDate.format("MMM. D, YYYY"),
    nextAuditDueDate: nextAuditDueDate.format("MMM. D, YYYY"),
    isPastDue,
    daysUntilNextAudit: isPastDue
      ? -Math.abs(daysUntilNextAudit)
      : daysUntilNextAudit,
  };
};

const currBrandName = "4imprint"

export const convertStatusToNormal = (status, orgId) => {
  if (status.toLowerCase() === "ci") {
    return "CI";
  }

  const clientStatus = getClientStatus(orgId);
  const brandReplaced = status.replace(/brand/i, clientStatus.clientName || "Client");
  
  return brandReplaced
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const getClientStatus = (orgId) => {
  if (orgId === "666b861f27affd9606bf67c9") {
    return {
      clientName: "4imprint",
      is4imprint: true
    };
  } else {
    return {
      clientName: "Client",
      is4imprint: false
    };
  }

};

/**
 * Auto-generate composition from fiber data
 * @param {Object} basicInfoFields - Array of basic information fields
 * @returns {string} - Generated composition string
 */
export const generateCompositionFromBasicInfo = (basicInfoFields) => {
  if (!basicInfoFields || !Array.isArray(basicInfoFields)) {
    return 'N/A';
  }

  const compositionParts = [];

  // Loop through all 6 fiber fields
  for (let i = 1; i <= 6; i++) {
    const fiberField = basicInfoFields.find(field => field.id === `fiber${i}`);
    const fiberPercentageField = basicInfoFields.find(field => field.id === `fiber${i}Percentage`);

    if (fiberField?.defaultValue && fiberPercentageField?.defaultValue) {
      compositionParts.push(`${fiberPercentageField.defaultValue}% ${fiberField.defaultValue}`);
    }
  }

  return compositionParts.join(', ') || 'N/A';
};